import React, { Component } from 'react';

export default class CustomSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownOpen: false,
      isAllSelected: false,
      searchValue: '',
    };
  }

  componentDidMount() {
    const { selectedItems, allItems, disableValue, listName } = this.props;

    if (selectedItems.includes(disableValue)) {
      this.props.action(
        listName,
        allItems.map((filter) => filter.id),
      );
    }

    this.setState(
      { isAllSelected: selectedItems.length === allItems.length },
      () => this.handlePlaceholderText(),
    );
  }

  UNSAFE_componentWillMount() {
    document.addEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  UNSAFE_componentWillReceiveProps(np) {
    const { selectedItems, allItems } = np;

    this.setState(
      { isAllSelected: selectedItems.length === allItems.length },
      () => this.handlePlaceholderText(),
    );
  }

  handlePlaceholderText = () => {
  const { allItems, selectedItems, placeHolderPlural, placeHolderSingular } =
    this.props;
  const searchElement = this.refs.searchInput;
  if (!searchElement) return;

  let placeholderText = `Select ${placeHolderSingular}`;

  if (selectedItems.length === allItems.length && allItems.length > 0) {
    placeholderText = `All ${placeHolderPlural} Selected`;
  } else if (selectedItems.length === 1) {
    const selected = allItems.find((item) => item.id === selectedItems[0]);
    placeholderText = selected?.name || `1 ${placeHolderSingular} Selected`;
  } else if (selectedItems.length > 1) {
    const first = allItems.find((item) => item.id === selectedItems[0]);
    const firstName = first?.name || selectedItems[0];
    const more = selectedItems.length - 1;
    placeholderText = `${firstName} + ${more} more`;
  }

  searchElement.placeholder = placeholderText;
};

  handleOutsideClick = (e) => {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({ isDropdownOpen: false, searchValue: '' });
    }
  };

  handleStateChangeFocus = () => {
    this.setState((prev) => ({
      isDropdownOpen: !prev.isDropdownOpen,
      searchValue: prev.isDropdownOpen ? '' : prev.searchValue,
    }));
  };

  handleSelectAll = () => {
    const { isAllSelected } = this.state;

    const { allItems, listName } = this.props;

    const items = isAllSelected ? [] : allItems.map((filter) => filter.id);

    this.props.action(listName, items);
  };

  isItemSelected = (state) => {
    const { selectedItems } = this.props;
    return selectedItems.indexOf(state) !== -1;
  };

  handleSelectItem = (item) => {
    const { selectedItems, listName, disableValue, allItems } = this.props;

    const selectedIndex = selectedItems.indexOf(item);

    if (disableValue && item === disableValue && selectedIndex === -1) {
      return this.props.action(
        listName,
        allItems.map((filter) => filter.id),
      );
    } else if (disableValue && item === disableValue) {
      return this.props.action(listName, []);
    }

    if (selectedIndex === -1) {
      selectedItems.push(item);
    } else {
      selectedItems.splice(selectedIndex, 1);
    }

    if (
      disableValue &&
      selectedItems.length !== allItems.length &&
      selectedItems.includes(disableValue)
    ) {
      return this.props.action(
        listName,
        selectedItems.filter((item) => item !== disableValue),
      );
    }

    if (disableValue && selectedItems.length === allItems.length - 1) {
      return this.props.action(
        listName,
        allItems.map((filter) => filter.id),
      );
    }

    this.props.action(listName, selectedItems);
  };

  handleSearch = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  getFilteredItems = () => {
  const { allItems, selectedItems } = this.props;
  const { searchValue } = this.state;

  let items = allItems;
  if (searchValue) {
    items = allItems.filter((item) =>
      item.name.toLowerCase().includes(searchValue.toLowerCase()),
    );
  }

  const selected = [];
  const unselected = [];
  items.forEach((item) => {
    if (selectedItems.includes(item.id)) {
      selected.push(item);
    } else {
      unselected.push(item);
    }
  });

  return selected.concat(unselected);
};

  render() {
    const { allItems, placeHolderSingular, isSelectAllRequired } = this.props;
    const { isDropdownOpen, isAllSelected, searchValue } = this.state;
    const filteredItems = this.getFilteredItems();

    return (
      <div
        className="custom-select-box-wrapper clearfix"
        ref={(node) => (this.node = node)}
      >
        <input
          type="text"
          className="form-control search-state"
          placeholder={`Select ${placeHolderSingular}`}
          ref="searchInput"
          readOnly
          onClick={this.handleStateChangeFocus}
        />
        {isDropdownOpen && allItems.length > 0 && (
          <div className="states-result broadcast-audience">
            <div className="blocks-wrapper">
              <div className="states-block sticky broadcast-search-block">
                <input
                  type="text"
                  className="form-control broadcast-search-input"
                  placeholder="Search"
                  value={searchValue}
                  onChange={this.handleSearch}
                />
              </div>
              {!searchValue && allItems.length > 1 && isSelectAllRequired && (
                <div className="states-block">
                  <input
                    type="checkbox"
                    className="checkbox-input"
                    checked={isAllSelected}
                    id={`select_all_${this.props.listName}`}
                    onChange={this.handleSelectAll}
                  />
                  <label
                    htmlFor={`select_all_${this.props.listName}`}
                    className="checkbox-label select-all"
                  >
                    All
                  </label>
                </div>
              )}
              {filteredItems.map((item) => (
                <div className="states-block" key={item.id}>
                  <input
                    type="checkbox"
                    className="checkbox-input"
                    id={item.id}
                    checked={this.isItemSelected(item.id)}
                    onChange={() => this.handleSelectItem(item.id)}
                  />
                  <label htmlFor={item.id} className="checkbox-label">
                    {item.name}
                  </label>
                </div>
              ))}
              {filteredItems.length === 0 && (
                <div className="states-block">
                  <span className="no-results-text">No results found</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
